exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sc-pre-invoice-cte__col[data-v-cac053a6] {\n  word-break: break-all;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-history/ScPreInvoiceDetailHistory.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB","file":"ScPreInvoiceDetailHistory.vue","sourcesContent":["\n.sc-pre-invoice-cte__col[data-v-cac053a6] {\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cac053a6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-history/ScPreInvoiceDetailHistory.vue
// module id = TYH1
// module chunks = 72